import React from 'react'
import { Children, Dispatch, SetStateAction } from "react";
import { Room } from "../../../../types/HotelType";
import styles from "./HotelViewPicker.module.scss";
import { hotelNumberPluralizer } from "../../../../utils/namePluralizer";

type HotelViewPickerProps = {
  rooms: Room[];
  children: React.ReactNode;
};
export function HotelViewPicker({ rooms, children }: HotelViewPickerProps){

  return (
    <div className={styles.views}>
      <h2 className={styles.heading}>{hotelNumberPluralizer(rooms[0].rooms.length)}</h2>
      { children }
    </div>
  );
}